var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.2,512c141.4-.6,255.5-115.8,254.8-257.2C511.4,113.5,396.2-.6,254.8,0,113.5.6-.6,115.8,0,257.1c.6,141.4,115.8,255.5,257.2,254.9ZM251.9,45.7c116.2-.5,210.8,93.2,211.3,209.4.5,116.2-93.3,210.8-209.4,211.3-116.2.5-210.8-93.2-211.3-209.4-.5-116.2,93.3-210.8,209.4-211.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.4,399.8c-10.4,0-20.3-.9-29.6-2.7-9.3-1.8-18.3-5.5-26.9-11.2-8.6-5.7-17.1-14.3-25.4-25.9-5.5.9-10.4,1.5-14.5,1.8-4.1.3-8.4.5-12.9.5-22.4,0-41.9-4.9-58.5-14.7-16.6-9.8-29.4-23.8-38.4-42.1-9-18.3-13.5-40.3-13.5-65.9s4.6-47.7,13.7-66.2c9.1-18.5,21.9-32.7,38.5-42.6,16.5-9.9,36-14.9,58.3-14.9s41.9,5,58.4,14.9c16.5,9.9,29.2,24.2,38.3,42.6,9.1,18.5,13.6,40.5,13.6,66.2s-3.3,41.1-9.9,57.7c-6.6,16.6-16.6,30.5-30.1,41.6,2.7,6.6,7.6,11.9,14.8,15.9,7.2,4,15.3,6,24.1,6.1v38.8ZM254.2,322.6c18.1,0,32.2-6.4,42.3-19.2,10.1-12.8,15.1-33.9,15.1-63.3s-5.1-51.1-15.2-64.4c-10.1-13.3-24.2-20-42.2-20s-32.1,6.7-42.1,20c-10.1,13.3-15.1,34.8-15.1,64.6s5,50.3,15.1,63.1c10.1,12.8,24.1,19.2,42.1,19.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionicon);
export default __webpack_public_path__ + "static/media/Question.icon.c917fb25e2b767563bba0d5bee226024.svg";
export { ForwardRef as ReactComponent };